// extracted by css-extract-rspack-plugin
export default {"label":"o0ebboIi70AEDq5k","required":"jxn_PX5y3Q2Umtg_"};